<div [ngClass]="{'expanded-background': !collapsed}" class="toggle-field-container toggle-group">
    <label [ngClass]="{'expanded-label': !collapsed}">{{ fieldName | translate }}</label>
    <label *ngIf="toggleVisible" class="switch">
    <input type="checkbox" [checked]="checked" (change)="onCheckboxChange($event)" />
    <span class="slider"></span>
    </label>
</div>